import { useState } from "react";
import { Link } from "react-router";
import { addDays, isScheduledOn, weekdayOf } from "@habitos/shared";
import { useAuth } from "../lib/auth";
import { useCheckIns, useHabits, useSetCheckIn } from "../lib/queries";
import { formatDay, WEEKDAY_LETTER, weekDates } from "../lib/format";

export function Week() {
  const { today } = useAuth();
  const [anchor, setAnchor] = useState(today);
  const days = weekDates(anchor);
  const from = days[0]!;
  const to = days[6]!;

  const habits = useHabits();
  const checkIns = useCheckIns(from, to);
  const setCheckIn = useSetCheckIn();

  const statusOf = (habitId: string, date: string) =>
    checkIns.data?.find((c) => c.habitId === habitId && c.date === date)?.status;

  const scheduled = days.reduce((n, d) => n + (habits.data ?? []).filter((h) => isScheduledOn(h, d)).length, 0);
  const done = (checkIns.data ?? []).filter((c) => c.status === "done").length;

  return (
    <>
      <header className="page-header">
        <div className="day-nav">
          <button className="icon-btn" aria-label="Semana anterior" onClick={() => setAnchor(addDays(anchor, -7))}>‹</button>
          <h1 className="small-h1">{formatDay(from)} – {formatDay(to)}</h1>
          <button className="icon-btn" aria-label="Semana siguiente" onClick={() => setAnchor(addDays(anchor, 7))}>›</button>
        </div>
        {scheduled > 0 && <p className="muted">Cumpliste {done} de {scheduled} esta semana.</p>}
        <Link to="/revision" className="btn review-link">Revisar mi semana</Link>
      </header>

      <div className="week card">
        <div className="week-row week-head">
          <span />
          {days.map((d) => (
            <span key={d} className={d === today ? "today" : ""}>{WEEKDAY_LETTER[weekdayOf(d)]}<br />{Number(d.slice(8))}</span>
          ))}
        </div>
        {(habits.data ?? []).map((h) => (
          <div key={h.id} className="week-row">
            <span className="week-habit" title={h.title}>{h.emoji ?? "•"} {h.title}</span>
            {days.map((d) => {
              if (!isScheduledOn(h, d)) return <span key={d} className="cell off" />;
              const status = statusOf(h.id, d);
              const future = d > today;
              return (
                <button
                  key={d}
                  className={`cell ${status ?? (d < today ? "missed" : "")}`}
                  disabled={future}
                  aria-label={`${h.title}, ${formatDay(d)}`}
                  onClick={() =>
                    setCheckIn.mutate({ habitId: h.id, date: d, status: status === "done" ? null : "done" })
                  }
                >
                  {status === "done" ? "✓" : status === "skipped" ? "–" : ""}
                </button>
              );
            })}
          </div>
        ))}
      </div>
      <p className="muted small center">Toca una casilla para marcarla como hecha.</p>
    </>
  );
}
